import { Typography, useTheme, styled } from '@mui/material';
import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';
import { createColorFilteredComponent } from 'helpers/styledHelpers';

const StyledContainer = createColorFilteredComponent<{ $color: string }>('div')(({ $color }) => ({
  display: 'flex',
  alignItems: 'center',
  color: $color
}));

const StyledTypography = styled(Typography)({
  marginLeft: '8px'
});

export const EmailVerifiedSection = (props: { emailVerified: boolean }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <StyledContainer $color={props.emailVerified ? theme.palette.secondary.main : theme.palette.red.main}>
        {props.emailVerified ? <CheckCircleIcon /> : <CancelIcon />}
        <StyledTypography variant="body1">
            {t(props.emailVerified ? 'profile.emailVerified' : 'profile.emailNotVerified')}
        </StyledTypography>
        </StyledContainer>
    );
}

export default EmailVerifiedSection;
